import { Component, OnInit } from "@angular/core";
import { OktaService } from "app/okta/okta.service";
import { UserDetailsService, UserDetailsWire } from 'app/shared/user-details.service';
import { ResourceService } from 'app/shared/resources/resource.service';

@Component({
    selector: "sbw-menu",
    styleUrls: ["./menu.component.css"],
    templateUrl: "./menu.component.html",
})
export class MenuComponent implements OnInit {
    public userDetailsWire: UserDetailsWire
    public showOkta: boolean;
    public serviceLinks: CustomerService = {}

    constructor(
        private userDetailsService: UserDetailsService,
        private resourceService: ResourceService,
        private oktaService: OktaService
    ) { }

    ngOnInit() {
        this.showOkta = window["okta_use"] == "true" ? true : false;
        this.resourceService.loadResources('Default', this.resourceService.getLocale(), ['Menu']);
        this.userDetailsService.getUserDetails().subscribe(data => {
            this.userDetailsWire = data
        })

        this.resourceService.get('ONLINE_HELP_LINK', false, 'Menu').subscribe(resource => {
            this.serviceLinks.onlineHelp = resource
        })

        this.resourceService.get('SUPPORT_PHONE_NUMBER', false, 'Menu').subscribe(resource => {
            if (/\d/.test(resource)) this.serviceLinks.contact = resource
        })
    }

    getReturnUrl(): string {
        return encodeURIComponent(location.pathname + location.search);
    }

    getLoginLink() {
        return `/_mvc/booking/account/login?returnUrl=${this.getReturnUrl()}`
    }

    getLogoutLink() {
        if (this.userDetailsWire.isAgent) return '/agent/account/logout'
        return '/_mvc/booking/account/logout'
    }
}

export interface CustomerService {
    onlineHelp?: string
    contact?: string
}
